import React from "react";
import { formatNumber, nFormatter, formatMoney } from "utils/currencyFormat";
import { formatCurrency } from "utils/currencyFormat";
import { getDate } from "utils/formatDate";
const QuyKhacTableRows = ({ list, pageIndex, pageSize,  btnSuaQuyClick, btnXoaQuyClick, RoleSuaQuy, RoleXoaQuy }) => {
  return list.List.map((item, index) => {
    return (
      <div className="custom-table-row" key={"item" + index} style={{minHeight:"40px"}}>
        <div className="custom-table-cell" style={{ width: "7%" }}>
          <span className="mobile-column-name color7-bold">STT</span>
          <div className="center-wrapper" >
            <p className="text-center color7">{(pageIndex - 1) * pageSize + index + 1}</p>
          </div>
        </div>
        <div className="custom-table-cell" style={{ width: "15%" }}>
          <span className="mobile-column-name color7-bold">Mã hợp đồng</span>
          <div className="center-wrapper">
            {item.Code}
          </div>
        </div>
        <div className="custom-table-cell" style={{ width: "15%" }}>
          <span className="mobile-column-name color7-bold">Nhân viên</span>
          <div className="center-wrapper">
            {item.NhanVien}
          </div>
        </div>
        <div className="custom-table-cell" style={{ width: "15%" }}>
          <span className="mobile-column-name color7-bold">Ngày giao dịch</span>
          <div className="center-wrapper">
            {getDate(item.Time)}
          </div>
        </div>
        <div className="custom-table-cell" style={{ width: "10%" }}>
          <span className="mobile-column-name color7-bold">Loại giao dịch</span>
          <div className="center-wrapper">
            {item.Type === 51
              ? "Nhập quỹ"
              : item.Type === 52
                ? "Rút quỹ"
                : "Chuyển quỹ"}
          </div>
        </div>
        <div className="custom-table-cell" style={{ width: "10%" }}>
          <span className="mobile-column-name color7-bold">Ghi chú</span>
          <div className="center-wrapper"
            style={{
              maxWidth: "100%",
              overflow: "hidden",
              whiteSpace: "nowrap",
              textOverflow: "ellipsis",
              margin: 0,
            }}
            title={item.Note}
          >
            {item.Note}
          </div>
        </div>
        <div className="custom-table-cell" style={{ width: "20%",textAlign:"end",paddingRight:"5%" }}>
          <span className="mobile-column-name color7-bold">Tổng tiền</span>
          <div className="center-wrapper color-do-bold">
            {formatNumber(item.Value)}
          </div>
        </div>
        <div className="custom-table-cell" style={{ width: "8%" }}>
          <span className="mobile-column-name color7-bold">Thao tác</span>
          <div className="" >
            {item.AllowAction && (
              <>
                {RoleSuaQuy && (
                  <>
                    <a
                      className="iconTableMorman"
                      title="Sửa"
                      onClick={() => btnSuaQuyClick(item)}
                    >
                      <img src="/app-assets/images/icon-edit-v2.png" />
                    </a>
                  </>
                )}
                {RoleXoaQuy && (
                  <>
                    <a
                      className="iconTableMorman"
                      title="Xóa"
                      onClick={() => btnXoaQuyClick(item.ThuChiId)}
                    >
                      <img src="/app-assets/images/icon-xoa-v2.png" />
                    </a>
                  </>
                )}
              </>
            )}
          </div>
        </div>
      </div>
    )
  });
};
const QuyKhacTable = ({ list, pageIndex, pageSize,  btnSuaQuyClick, btnXoaQuyClick, RoleSuaQuy, RoleXoaQuy }) => {
  if (!list || list.List.length === 0) {
    return (
      <div className="custom-table-row">
        <div className="custom-table-cell text-center red" style={{ width: "100%" }}>
          Không có dữ liệu
        </div>
      </div>
    );
  }
  return (
    <div className="Left808x200 Table-main-new css-table-ds">
      <div className="table-mobile table-mobile-hover">
        <div className="custom-table-wrapper">
          <div className="table-headers" >
            <div className="custom-table-header text-center " style={{ width: "7%" }}>
              <p className="color-do-bold">
                STT
                <br />[{list.iTotal === 0 ? 0 : list.iTotal}]
              </p>
            </div>
            <div className="custom-table-header" style={{ width: "15%" }}>
              <p>Mã hợp đồng</p>
            </div>
            <div className="custom-table-header" style={{ width: "15%" }}>
              <p>Nhân viên</p>
            </div>
            <div className="custom-table-header" style={{ width: "15%" }}>
              <p>Ngày giao dịch</p>
            </div>
            <div className="custom-table-header" style={{ width: "10%" }}>
              <p>Loại giao dịch</p>
            </div>
            <div className="custom-table-header" style={{ width: "10%" }}>
              <p>Ghi chú</p>
            </div>
            <div className="custom-table-header" style={{ width: "20%" ,textAlign:"end",paddingRight:"5%"}}>
              <p>Tổng tiền</p>
              <p className="color-do-bold">$ = {formatCurrency(list.iTotal1)}</p>
            </div>
            <div className="custom-table-header" style={{ width: "8%" }}>
              <p>Thao tác</p>
            </div>
          </div>
          <div className="custom-table-body">
            <QuyKhacTableRows
              list={list}
              pageIndex={pageIndex}
              pageSize={pageSize}
              btnSuaQuyClick={btnSuaQuyClick}
              btnXoaQuyClick={btnXoaQuyClick}
              RoleSuaQuy={RoleSuaQuy}
              RoleXoaQuy={RoleXoaQuy}
            />
          </div>
        </div>
      </div>
    </div>
  )
};

export default QuyKhacTable;